<div class="gameWrap gameZooLotto">
    <div class="gameHeader">
        <button class="back leftbtn" (click)="loadBack()">
            <a>
                <svg class="svgicon">
                    <use xlink:href="assets/images/sprite-sheet.svg#icon-leftarrow"></use>
                </svg>
            </a>
        </button>
        <div class="pageIndicator">
            <div class="imgWrap">
                <img src="assets/images/{{clientCode}}/gamelogo/{{rootData?.gameIcon}}"
                    alt="game-{{gameData?.gameName}}">
            </div>
            <div class="userinfo">
                <!-- **new** -whole-block -->
                <div class="userName">{{userInfo?.playername}}</div>
                <div class="balanceWrap" innerHTML="{{userInfo?.balance | custCurrency}}"></div>
            </div>
        </div>
    </div>
    <div class="timeToDrawSection">
        <!-- **new** -whole-block -->
        <div class="sectionWrapper">
            <div class="section msgBlk">
                <div class="boxWrap {{myTicketCount > 0 ? 'played' : 'no-played'}}">
                    <div class="box">
                        <div class="title">{{'dge.play_ticket' | translate}}</div>
                        <div class="subTitle">{{'dge.for_draw' | translate}}</div>
                    </div>
                    <div class="value">{{ myTicketCount }}</div>
                </div>
                <div class="dmPlayBTNWrap" (click)="openDrawMachine()">
                    <button class="dmPlayBTN btn">
                        <span>{{'dge.play' | translate}}</span>
                    </button>
                </div>
            </div>
            <div class="section timerBlk" *ngIf="diff_time?.fetchRuleStatus">
                <div class="label">{{'dge.curr_draw' | translate}}</div>
                <div class="timer">
                    <div class="box day" *ngIf="true">
                        <span class="num">{{diff_time?.shownTime[0]}}</span>
                        <span class="abbr">D</span>
                    </div>
                    <div class="box hour">
                        <span class="num">{{diff_time?.shownTime[1]}}</span>
                        <span class="abbr">H</span>
                    </div>
                    <div class="box minute">
                        <span class="num">{{diff_time?.shownTime[2]}}</span>
                        <span class="abbr">M</span>
                    </div>
                    <div class="box second">
                        <span class="num">{{diff_time?.shownTime[3]}}</span>
                        <span class="abbr">S</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="betTypeWrap section">
        <div class="sectionWrapper">
            <div class="resultTime-box">
                <div class="lastResultWrap"></div>
                <div class="preBtnWrap" routerLink="/dge/results/{{gameCode}}" routerLinkActive="active">
                    <div class="preBtn">
                        <div class="label" innerHTML="{{'common.prev_res' | translate}}"></div>
                        <span class="icon"></span>
                    </div>
                </div>
            </div>
            <div class="betBlockWrap">
                <div class="betType-box">
                    <div class="mainBetWrap sectionBox current">
                        <div class="sectionTitle">{{'dge.bet_type' | translate}}</div>
                        <ul class="buttonList">
                            <ng-container *ngFor="let betType of gameData?.betRespVOs; let i = index">
                                <li *ngIf="betType.winMode == 'MAIN'"
                                    [ngClass]="{'active': userData?.panelData[panelCounter - 1]?.betType == betType.betCode}"
                                    [attr.betname]="betType.betName" (click)="selectGameBet(betType.betCode)"
                                    tabindex="-1" (keyup.arrowleft)="moveBetFocus($event, 'LEFT', i)"
                                    (keyup.arrowright)="moveBetFocus($event, 'RIGHT', i)"
                                    (focus)="selectGameBet(betType.betCode)">
                                    <button>{{'dge.'+betType?.betDispName | translate}}</button>
                                </li>
                            </ng-container>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="gameplayWrap section">
        <div class="gameHeader subHeader">
            <button class="back leftbtn" (click)="loadBack()">
                <a>
                    <svg class="svgicon">
                        <use xlink:href="assets/images/sprite-sheet.svg#icon-leftarrow"></use>
                    </svg>
                </a>
            </button>
            <div class="pageIndicator">
                <div class="title">{{'common.'+betTypeCodeName | translate}}</div>
                <div class="userinfo">
                    <div class="userName">{{userInfo?.playername}}</div>
                    <div class="balanceWrap" innerHTML="{{userInfo?.balance | custCurrency}}"></div>
                </div>
            </div>
        </div>
        <div class="playAreaWrapper">
            <div class="mainBetWrapper">
                <div class="sectionWrapper">
                    <div class="plNumberEnterWrap" *ngIf="betTypeCodeName == 'Milhar' || betTypeCodeName == 'Centena' || betTypeCodeName == 'MilharCentena' || betTypeCodeName == 'Milhar1to5' || betTypeCodeName == 'MilharCentena1to5' || betTypeCodeName == 'Centena1to5'">
                        <ul>
                            <ng-container *ngFor="let item of [].constructor(4); let i = index">
                                <li
                                    [ngClass]="{'disabled': (betTypeCodeName == 'Centena' || betTypeCodeName == 'Centena1to5') && i == 0}">
                                    <input type="text"  maxlength="1"   placeholder="*" autocomplete="off"  (click)="selectInputField(i, $event)"
                                    [disabled] = "(betTypeCodeName == 'Centena' || betTypeCodeName == 'Centena1to5') && i == 0"
                                        [ngClass]="{'autofocus': i == inputFieldIndex}" id="inputField{{i}}"   (keydown)="checkValid($event)" (keyup)="selectInputField(i, $event)"      tabindex="-1"  >
                                    <div class="numBoxWrap" style="display: block;"
                                        *ngIf="i == inputFieldIndex && isAutoFocus ">
                                        <ul>
                                            <li class="button" *ngFor="let data of [].constructor(10); let j = index"
                                            (click)="selectOrEnterAutoFocusNumber(i, j)">
                                                {{j}}
                                            </li>
                                            <li class="button bigText" (click)="selectOrEnterAutoFocusNumber(i, 'clear')">
                                                Clear
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="numBoxWrap" style="display: none;" *ngIf="i != inputFieldIndex">
                                    </div>
                                </li>
                            </ng-container>
                        </ul>
                        <!-- <ul>
                            <li class="disabled">
                                <input type="text" maxlength="1" placeholder="*" disabled>
                                <div class="numBoxWrap">
                                    <ul>
                                        <li class="button">1</li>
                                        <li class="button">2</li>
                                        <li class="button">3</li>
                                        <li class="button">4</li>
                                        <li class="button">5</li>
                                        <li class="button">6</li>
                                        <li class="button">7</li>
                                        <li class="button">8</li>
                                        <li class="button">9</li>
                                        <li class="button">0</li>
                                        <li class="button bigText">Clear</li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <input type="text" maxlength="1" value="7">
                                <div class="numBoxWrap">
                                    <ul>
                                        <li class="button">1</li>
                                        <li class="button">2</li>
                                        <li class="button">3</li>
                                        <li class="button">4</li>
                                        <li class="button">5</li>
                                        <li class="button">6</li>
                                        <li class="button">7</li>
                                        <li class="button">8</li>
                                        <li class="button">9</li>
                                        <li class="button">0</li>
                                        <li class="button bigText">Clear</li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <input type="text" maxlength="1" value="9">
                                <div class="numBoxWrap">
                                    <ul>
                                        <li class="button">1</li>
                                        <li class="button">2</li>
                                        <li class="button">3</li>
                                        <li class="button">4</li>
                                        <li class="button">5</li>
                                        <li class="button">6</li>
                                        <li class="button">7</li>
                                        <li class="button">8</li>
                                        <li class="button">9</li>
                                        <li class="button">0</li>
                                        <li class="button bigText">Clear</li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <input type="text" maxlength="1" placeholder="*" autofocus>
                                <div class="numBoxWrap" style="display: block;">
                                    <ul>
                                        <li class="button">1</li>
                                        <li class="button">2</li>
                                        <li class="button">3</li>
                                        <li class="button">4</li>
                                        <li class="button">5</li>
                                        <li class="button">6</li>
                                        <li class="button">7</li>
                                        <li class="button">8</li>
                                        <li class="button">9</li>
                                        <li class="button">0</li>
                                        <li class="button bigText">Clear</li>
                                    </ul>
                                </div>
                            </li>
                        </ul> -->
                    </div>
                    <div class="animalNumWrap" *ngIf="betTypeCodeName == 'Groupo' || betTypeCodeName == 'TurnoDeGroupo'">
                        <ul>
                            <!-- <li [ngClass]="{selected: animalPanelData[j] == (item.key).split(',')[1]}" *ngFor="let item of animalNameGroupNumbersMapping | keyvalue; let j = index">
                                <div class="animalBlk" (click)="selectAnimal((item.key).split(',')[1], item, j)">
                                    <div class="blk-title">
                                        <div class="num">{{(item.key).split(',')[1]}}</div>
                                        <div class="name">{{(item.key).split(',')[0]}}</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/{{(item.key).split(',')[1]}}{{(item.key).split(',')[0]}}.jpg" alt="{{(item.key).split(',')[0]}}">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">{{item.value[0]}}</div>
                                        <div class="num">{{item.value[1]}}</div>
                                        <div class="num">{{item.value[2]}}</div>
                                        <div class="num">{{item.value[3]}}</div>
                                    </div>
                                </div>
                            </li> -->
                            <li [ngClass]="{selected: animalPanelData[j] == animalNameGroupNumbersMappingKey[j].split(',')[1]}" *ngFor="let item of animalNameGroupNumbersMappingValue; let j = index;">
                                <div class="animalBlk" (click)="selectAnimal(animalNameGroupNumbersMappingKey[j].split(',')[1], animalNameGroupNumbersMappingKey[j].split(',')[0], item, j)">
                                    <div class="blk-title">
                                        <div class="num">{{animalNameGroupNumbersMappingKey[j].split(',')[1]}}</div>
                                        <div class="name">{{animalNameGroupNumbersMappingKey[j].split(',')[0]}}</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/{{animalNameGroupNumbersMappingKey[j].split(',')[1]}}{{animalNameGroupNumbersMappingKey[j].split(',')[0]}}.jpg" alt="{{animalNameGroupNumbersMappingKey[j].split(',')[0]}}">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">{{item[0]}}</div>
                                        <div class="num">{{item[1]}}</div>
                                        <div class="num">{{item[2]}}</div>
                                        <div class="num">{{item[3]}}</div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="animalNumWrap" style="display:none;">
                        <ul>
                            <li>
                                <div class="animalBlk">
                                    <div class="blk-title">
                                        <div class="num">01</div>
                                        <div class="name">Avestruz</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/01Avestruz.jpg" alt="Avestruz">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">01</div>
                                        <div class="num">02</div>
                                        <div class="num">03</div>
                                        <div class="num">04</div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="animalBlk">
                                    <div class="blk-title">
                                        <div class="num">02</div>
                                        <div class="name">Águia</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/02Águia.jpg" alt="Águia">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">05</div>
                                        <div class="num">06</div>
                                        <div class="num">07</div>
                                        <div class="num">08</div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="animalBlk">
                                    <div class="blk-title">
                                        <div class="num">03</div>
                                        <div class="name">Burro</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/03Burro.jpg" alt="Burro">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">09</div>
                                        <div class="num">10</div>
                                        <div class="num">11</div>
                                        <div class="num">12</div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="animalBlk">
                                    <div class="blk-title">
                                        <div class="num">04</div>
                                        <div class="name">Borboleta</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/04Borboleta.jpg" alt="Borboleta">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">13</div>
                                        <div class="num">14</div>
                                        <div class="num">15</div>
                                        <div class="num">16</div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="animalBlk">
                                    <div class="blk-title">
                                        <div class="num">05</div>
                                        <div class="name">Cachorro</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/05Cachorro.jpg" alt="Cachorro">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">17</div>
                                        <div class="num">18</div>
                                        <div class="num">19</div>
                                        <div class="num">20</div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="animalBlk">
                                    <div class="blk-title">
                                        <div class="num">06</div>
                                        <div class="name">Cabra</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/06Cabra.jpg" alt="Cabra">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">21</div>
                                        <div class="num">22</div>
                                        <div class="num">23</div>
                                        <div class="num">24</div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="animalBlk">
                                    <div class="blk-title">
                                        <div class="num">07</div>
                                        <div class="name">Carneiro</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/07Carneiro.jpg" alt="Carneiro">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">25</div>
                                        <div class="num">26</div>
                                        <div class="num">27</div>
                                        <div class="num">28</div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="animalBlk">
                                    <div class="blk-title">
                                        <div class="num">08</div>
                                        <div class="name">Camelo</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/08Camelo.jpg" alt="Camelo">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">29</div>
                                        <div class="num">30</div>
                                        <div class="num">31</div>
                                        <div class="num">32</div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="animalBlk">
                                    <div class="blk-title">
                                        <div class="num">09</div>
                                        <div class="name">Cobra</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/09Cobra.jpg" alt="Cobra">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">33</div>
                                        <div class="num">34</div>
                                        <div class="num">35</div>
                                        <div class="num">36</div>
                                    </div>
                                </div>
                            </li>
                            <li class="selected">
                                <div class="animalBlk">
                                    <div class="blk-title">
                                        <div class="num">10</div>
                                        <div class="name">Coelho</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/10Coelho.jpg" alt="Coelho">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">37</div>
                                        <div class="num">38</div>
                                        <div class="num">39</div>
                                        <div class="num">40</div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="animalBlk">
                                    <div class="blk-title">
                                        <div class="num">11</div>
                                        <div class="name">Cavalo</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/11Cavalo.jpg" alt="Cavalo">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">41</div>
                                        <div class="num">42</div>
                                        <div class="num">43</div>
                                        <div class="num">44</div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="animalBlk">
                                    <div class="blk-title">
                                        <div class="num">12</div>
                                        <div class="name">Elefante</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/12Elefante.jpg" alt="Elefante">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">45</div>
                                        <div class="num">46</div>
                                        <div class="num">47</div>
                                        <div class="num">48</div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="animalBlk">
                                    <div class="blk-title">
                                        <div class="num">13</div>
                                        <div class="name">Galo</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/13Galo.jpg" alt="Galo">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">49</div>
                                        <div class="num">50</div>
                                        <div class="num">51</div>
                                        <div class="num">52</div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="animalBlk">
                                    <div class="blk-title">
                                        <div class="num">14</div>
                                        <div class="name">Gato</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/14Gato.jpg" alt="Gato">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">53</div>
                                        <div class="num">54</div>
                                        <div class="num">55</div>
                                        <div class="num">56</div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="animalBlk">
                                    <div class="blk-title">
                                        <div class="num">15</div>
                                        <div class="name">Jacaré</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/15Jacaré.jpg" alt="Jacaré">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">57</div>
                                        <div class="num">58</div>
                                        <div class="num">59</div>
                                        <div class="num">60</div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="animalBlk">
                                    <div class="blk-title">
                                        <div class="num">16</div>
                                        <div class="name">Leão</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/16Leão.jpg" alt="Leão">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">61</div>
                                        <div class="num">62</div>
                                        <div class="num">63</div>
                                        <div class="num">64</div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="animalBlk">
                                    <div class="blk-title">
                                        <div class="num">17</div>
                                        <div class="name">Macaco</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/17Macaco.jpg" alt="Macaco">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">65</div>
                                        <div class="num">66</div>
                                        <div class="num">67</div>
                                        <div class="num">68</div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="animalBlk">
                                    <div class="blk-title">
                                        <div class="num">18</div>
                                        <div class="name">Porco</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/18Porco.jpg" alt="Porco">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">69</div>
                                        <div class="num">70</div>
                                        <div class="num">71</div>
                                        <div class="num">72</div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="animalBlk">
                                    <div class="blk-title">
                                        <div class="num">19</div>
                                        <div class="name">Pavão</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/19Pavão.jpg" alt="Pavão">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">73</div>
                                        <div class="num">74</div>
                                        <div class="num">75</div>
                                        <div class="num">76</div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="animalBlk">
                                    <div class="blk-title">
                                        <div class="num">20</div>
                                        <div class="name">Peru</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/20Peru.jpg" alt="Peru">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">77</div>
                                        <div class="num">78</div>
                                        <div class="num">79</div>
                                        <div class="num">80</div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="animalBlk">
                                    <div class="blk-title">
                                        <div class="num">21</div>
                                        <div class="name">Touro</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/21Touro.jpg" alt="Touro">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">81</div>
                                        <div class="num">82</div>
                                        <div class="num">83</div>
                                        <div class="num">84</div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="animalBlk">
                                    <div class="blk-title">
                                        <div class="num">22</div>
                                        <div class="name">Tigre</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/22Tigre.jpg" alt="Tigre">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">85</div>
                                        <div class="num">86</div>
                                        <div class="num">87</div>
                                        <div class="num">88</div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="animalBlk">
                                    <div class="blk-title">
                                        <div class="num">23</div>
                                        <div class="name">Urso</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/23Urso.jpg" alt="Urso">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">89</div>
                                        <div class="num">90</div>
                                        <div class="num">91</div>
                                        <div class="num">92</div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="animalBlk">
                                    <div class="blk-title">
                                        <div class="num">24</div>
                                        <div class="name">Veado</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/24Veado.jpg" alt="Veado">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">93</div>
                                        <div class="num">94</div>
                                        <div class="num">95</div>
                                        <div class="num">96</div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="animalBlk">
                                    <div class="blk-title">
                                        <div class="num">25</div>
                                        <div class="name">Vaca</div>
                                    </div>
                                    <div class="blk-image">
                                        <img src="assets/images/animals/25Vaca.jpg" alt="Vaca">
                                    </div>
                                    <div class="coreNum">
                                        <div class="num">97</div>
                                        <div class="num">98</div>
                                        <div class="num">99</div>
                                        <div class="num">00</div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="betAmountWrap sectionBox">
                        <div class="sectionTitle">{{'dge.betamt' | translate}}</div>
                        <ul class="buttonList">
                            <ng-container *ngFor="let betAmt of betAmtArray; let j = index">
                                <li *ngIf="j < 5" (click)="selectBetAmount(j, betAmt)" id="unitPrice-{{j+1}}"
                                    [ngClass]="{'active': ((j+1) == userData?.panelData[panelCounter - 1]?.betAmountMultiple )}"
                                    (focus)="selectBetAmount(j, betAmt)">
                                    <button innerHTML="{{betAmt | custCurrency}}"></button>
                                </li>
                            </ng-container>
                            <li [ngClass]="{'active' : activateOtherAmt()}"
                                *ngIf="gameData?.betRespVOs[0]?.maxBetAmtMul * gameData?.betRespVOs[0]?.unitPrice != gameData?.betRespVOs[0]?.unitPrice">
                                <button class="otherBtn" id="otherBtn-1" [ngClass]="{'selected': showOtherAmountInput}"
                                    (click)="selectOtherAmount($event)" (focus)="selectOtherAmount($event)">
                                    <span class="label">{{'dge.other' | translate}}</span>
                                    <span class="currency">{{userInfo?.currDisplay | currencySymbol}}</span>
                                    <input type="text" id="otherAmt-1" [(ngModel)]="otherAmtVal" name="otherTextBox"
                                        (keyup)="onOtherAmtInputChange($event)" maxlength="6">
                                </button>
                            </li>
                        </ul>
                        <span class="error">{{betError}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="addResetWrap mainBetPanelReset fix-bottom">
            <div class="sectionWrapper">
                <!-- style="display: none;" on postState or preState-->
                <div class="postState" [ngClass]="{'hide': postState}">
                    <div class="postStateInner">
                        <div class="powerzone type1">
                            <div class="betInfoWrap">
                                <div class="betInfo">
                                    <div class="txt">{{numberOfLines(0)}}</div>
                                    <div class="label">{{'dge.no_line' | translate}}</div>
                                </div>
                                <div class="betInfo">
                                    <div class="txt" innerHTML="{{calculatePanelPrice(0) | custCurrency}}"></div>
                                    <div class="label">{{'dge.bet_val' | translate}}</div>
                                </div>
                            </div>
                            <button class="reset" (click)="resetUserData()">
                                <svg class="svgicon">
                                    <use xlink:href="assets/images/sprite-sheet.svg#icon-reset"></use>
                                </svg>
                                <div class="txt">{{'dge.reset' | translate}}</div>
                            </button>
                            <button class="info" (click)="openHelpModal(gameCode)">
                                <span class="infoIcon">i</span>
                                <div class="txt"
                                    innerHtml="{{'common.rultoply' | translate:{gameCode: 'common.'+gameCode | translate} }}">
                                </div>
                            </button>
                            <button class="addBet btn-primary" (click)="addMainPanel()"
                                [disabled]="calculatePanelPrice(0) == 0"
                                [ngClass]="{'disabled':calculatePanelPrice(0) == 0}">
                                {{'dge.addbet' | translate}}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="preState" [ngClass]="{'hide': !postState}">
                    <div class="preStateInner">
                        <div class="msgTxt">{{postStateMsg}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="purchaseOuterWrap"></div>
    <div class="confirmPurchaseOuterWrap"></div>
    <div class="infobtnWrap" (click)="openHelpModal(gameCode)">
        <button class="info">
            <span class="infoIcon">i</span>
            <div class="txt" innerHtml="{{'common.rultoply' | translate:{gameCode: 'common.'+gameCode | translate} }}">
            </div>
        </button>
    </div>
</div>
<div class="game-start-timer-wrap" *ngIf="saleTimerStatus">
    <div class="game-start-timer">
        <div class="titleWrap">
            <div class="title1">{{'common.market_unavailable' | translate}}</div>
            <div class="title2">{{'common.sale_start' | translate}}</div>
        </div>
        <div class="timerWrap">
            <div class="timer">
                <div class="unit days" *ngIf="diff_time?.convention.includes('day')">
                    <div class="value">{{diff_time?.saleShownTime[0]}}</div>
                    <div class="label">{{diff_time?.shownTime[0] == 1 ? 'Day' : 'Days'}}</div>
                </div>
                <div class="unit hours"
                    *ngIf="diff_time?.convention.includes('day') || diff_time?.convention.includes('hr')">
                    <div class="value">{{diff_time?.saleShownTime[1]}}</div>
                    <div class="label">{{diff_time?.shownTime[1] == 1 ? 'Hour' : 'Hours'}}</div>
                </div>
                <div class="unit minutes">
                    <div class="value">{{diff_time?.saleShownTime[2]}}</div>
                    <div class="label">{{diff_time?.shownTime[2] == 1 ? 'Minute' : 'Minutes'}}</div>
                </div>
                <div class="unit seconds">
                    <div class="value">{{diff_time?.saleShownTime[3]}}</div>
                    <div class="label">{{diff_time?.shownTime[3] == 1 ? 'Second' : 'Seconds'}}</div>
                </div>
            </div>
        </div>
        <div class="actionBtnWrap">
            <button class="btn btn-rules" (click)="openHelpModal(gameCode)"
                innerHtml="{{'common.rultoply' | translate:{gameCode: ''} }}"></button>
            <button class="btn btn-results" routerLink="/dge/results/{{gameCode}}" routerLinkActive="active"
                innerHTML="{{'common.prev_res' | translate}}"></button>
        </div>
    </div>
</div>
<div class="game-start-timer-wrap" *ngIf="!activeDrawStatus">
    <div class="game-start-timer">
        <div class="titleWrap">
            <div class="title1">{{'dge.noDraws' | translate}}</div>
            <div class="title2"></div>
        </div>
        <div class="timerWrap">
            <svg id="b21613c9-2bf0-4d37-bef0-3b193d34fc5d" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                width="647.63626" height="632.17383" viewBox="0 0 647.63626 632.17383">
                <path
                    d="M687.3279,276.08691H512.81813a15.01828,15.01828,0,0,0-15,15v387.85l-2,.61005-42.81006,13.11a8.00676,8.00676,0,0,1-9.98974-5.31L315.678,271.39691a8.00313,8.00313,0,0,1,5.31006-9.99l65.97022-20.2,191.25-58.54,65.96972-20.2a7.98927,7.98927,0,0,1,9.99024,5.3l32.5498,106.32Z"
                    transform="translate(-276.18187 -133.91309)" fill="#f2f2f2" />
                <path
                    d="M725.408,274.08691l-39.23-128.14a16.99368,16.99368,0,0,0-21.23-11.28l-92.75,28.39L380.95827,221.60693l-92.75,28.4a17.0152,17.0152,0,0,0-11.28028,21.23l134.08008,437.93a17.02661,17.02661,0,0,0,16.26026,12.03,16.78926,16.78926,0,0,0,4.96972-.75l63.58008-19.46,2-.62v-2.09l-2,.61-64.16992,19.65a15.01489,15.01489,0,0,1-18.73-9.95l-134.06983-437.94a14.97935,14.97935,0,0,1,9.94971-18.73l92.75-28.4,191.24024-58.54,92.75-28.4a15.15551,15.15551,0,0,1,4.40966-.66,15.01461,15.01461,0,0,1,14.32032,10.61l39.0498,127.56.62012,2h2.08008Z"
                    transform="translate(-276.18187 -133.91309)" fill="#3f3d56" />
                <path
                    d="M398.86279,261.73389a9.0157,9.0157,0,0,1-8.61133-6.3667l-12.88037-42.07178a8.99884,8.99884,0,0,1,5.9712-11.24023l175.939-53.86377a9.00867,9.00867,0,0,1,11.24072,5.9707l12.88037,42.07227a9.01029,9.01029,0,0,1-5.9707,11.24072L401.49219,261.33887A8.976,8.976,0,0,1,398.86279,261.73389Z"
                    transform="translate(-276.18187 -133.91309)" fill="#1a67d5" />
                <circle cx="190.15351" cy="24.95465" r="20" fill="#1a67d5" />
                <circle cx="190.15351" cy="24.95465" r="12.66462" fill="#fff" />
                <path
                    d="M878.81836,716.08691h-338a8.50981,8.50981,0,0,1-8.5-8.5v-405a8.50951,8.50951,0,0,1,8.5-8.5h338a8.50982,8.50982,0,0,1,8.5,8.5v405A8.51013,8.51013,0,0,1,878.81836,716.08691Z"
                    transform="translate(-276.18187 -133.91309)" fill="#e6e6e6" />
                <path
                    d="M723.31813,274.08691h-210.5a17.02411,17.02411,0,0,0-17,17v407.8l2-.61v-407.19a15.01828,15.01828,0,0,1,15-15H723.93825Zm183.5,0h-394a17.02411,17.02411,0,0,0-17,17v458a17.0241,17.0241,0,0,0,17,17h394a17.0241,17.0241,0,0,0,17-17v-458A17.02411,17.02411,0,0,0,906.81813,274.08691Zm15,475a15.01828,15.01828,0,0,1-15,15h-394a15.01828,15.01828,0,0,1-15-15v-458a15.01828,15.01828,0,0,1,15-15h394a15.01828,15.01828,0,0,1,15,15Z"
                    transform="translate(-276.18187 -133.91309)" fill="#3f3d56" />
                <path
                    d="M801.81836,318.08691h-184a9.01015,9.01015,0,0,1-9-9v-44a9.01016,9.01016,0,0,1,9-9h184a9.01016,9.01016,0,0,1,9,9v44A9.01015,9.01015,0,0,1,801.81836,318.08691Z"
                    transform="translate(-276.18187 -133.91309)" fill="#1a67d5" />
                <circle cx="433.63626" cy="105.17383" r="20" fill="#1a67d5" />
                <circle cx="433.63626" cy="105.17383" r="12.18187" fill="#fff" />
            </svg>
        </div>
        <div class="actionBtnWrap">
            <button class="btn btn-rules" (click)="openHelpModal(gameCode)"
                innerHtml="{{'common.rultoply' | translate:{gameCode: ''} }}"></button>
            <button class="btn btn-results" routerLink="/dge/results/{{gameCode}}" routerLinkActive="active"
                innerHTML="{{'common.prev_res' | translate}}"></button>
        </div>
    </div>
</div>

<!-- modal-box:: "Other" Bet Amount -->
<!-- <div class="modal-box modal-xs modal-design1" *ngIf="showOtherAmountInput">
    <div class="modal-content">
        <div class="modal-header">
            <div class="modal-title">{{'dge.amt' | translate}}</div>
            <div class="modal-close" (click)="closeOtherAmountInput()"><span></span></div>
        </div>
        <div class="modal-body">
            <div class="otherAmount">
                <ul class="buttonList">
                    <ng-container *ngFor="let betAmt of betAmtArray; let j = index">
                        <li *ngIf="j > 4" (click)="selectOtherBetAmount(j, betAmt)" id="unitPrice-{{j+1}}"
                            [ngClass]="{'active': (j+1) == otherBetAmountMultiple}"
                            (focus)="selectOtherBetAmount(j, betAmt)">
                            <button><span
                                    class="currency">{{userInfo?.currDisplay | currencySymbol}}</span>{{betAmt | number:'1.2-2'}}</button>
                        </li>
                    </ng-container>
                </ul>
                <div class="inputWrap">
                    <label for="otherBetAmount">{{'dge.amt' | translate}}</label>
                    <input type="text" id="otherAmt-1" [(ngModel)]="otherAmtVal"
                        (keyup)="onOtherAmtInputChange($event)">
                    <span class="error">{{betError}}</span>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="buttonWrap" (click)="closeOtherAmountInput()">
                <a>
                    <div class="cancelBtn button">
                        <div class="text">{{'dge.cancel' | translate}}</div>
                    </div>
                </a>
            </div>
            <div class="buttonWrap" (click)="continueOtherAmountInput()">
                <a>
                    <div class="goBtn button">
                        <div class="text">{{'dge.cont' | translate}}</div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</div> -->

